import { useAppSelector } from "../store/hooks";
import hasOwnProperty from "../helpers/object";

const useGetOnGoing = (key: string | string[]): boolean => {
  const ongoing = useAppSelector((state) => state.ongoing);
  if (Array.isArray(key)) return key.some((k) => hasOwnProperty(ongoing, k));

  return hasOwnProperty(ongoing, key);
};

export default useGetOnGoing;
